interface Organization {
  providerId: number;
  slug: string;
}

export function checkIsOnDash(path: string, organization: Organization) {
  return path.startsWith(
    `/dash/${organization.providerId}/${organization.slug}`
  );
}

export function replaceOrganizationUrl(
  path: string,
  organization: Organization,
  newOrganization: Organization
) {
  const urlParts = path.split('/');
  const isOnDash = checkIsOnDash(path, organization);
  const slugIndex = isOnDash ? 3 : 4;
  const providerIndex = isOnDash ? 2 : 3;
  urlParts[slugIndex] = newOrganization.slug;
  urlParts[providerIndex] = newOrganization.providerId.toString();

  return urlParts.join('/') + '/';
}

export function getSectionUrl(url: string, organization: Organization) {
  // if on dash, there is no section
  if (checkIsOnDash(url, organization)) {
    return url;
  }

  // cut everything after the organization slug
  // which is in position 4 in the array
  const urlParts = url.split('/');
  return urlParts.slice(0, 5).join('/') + '/';
}

const GITHUB_REGEX = /^((http(s)?):\/\/)?(www\.)?(github\.com)\/[^\s?&=*]+$/i;
const LINKEDIN_REGEX =
  /^((http(s)?):\/\/)?(www\.)?(linkedin\.com)\/(in)\/[^\s?&=*]+$/i;

export function isValidGithubUrl(url?: string): boolean {
  if (!url) {
    return false;
  }

  return GITHUB_REGEX.test(url);
}

export function isValidLinkedinUrl(url?: string): boolean {
  if (!url) {
    return false;
  }

  return LINKEDIN_REGEX.test(url);
}

export function extractGithubProfileName(url?: string) {
  if (!url || !isValidGithubUrl(url)) {
    return null;
  }

  // if there's a trailing slash on the github url, remove it
  let split;
  if (url.charAt(url.length - 1) === '/') {
    split = url.substring(0, url.length - 1).split('/');
  } else {
    split = url?.split('/');
  }

  return split[split.length - 1];
}
